var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"itemcard"},[_c('div',{staticClass:"no-search-result"},[_c('img',{attrs:{"src":"/images/order/icon_22.png"}}),_c('div',{staticClass:"no-search-text"},[_c('p',{staticClass:"one"},[_vm._v("暂无相关订单。")]),_c('p',{staticClass:"two"},[_vm._v("请稍后再试")])])])])])
}]

export { render, staticRenderFns }